<template>
  <div id="main">
    <div class="bg">
      <Transition :name="formFadeName">
        <div class="hub-logo" v-if="formShow && !success">
          <img :src="$assets.svg['hub_logo_white']" alt="" />
          <p>Let’s begin with some basic information about yourself and your agency.</p>
        </div>
      </Transition>

      <Transition :name="formFadeName">
        <div class="intro-title" v-if="welcomeShow">Welcome To HUB Registration Page</div>
      </Transition>
    </div>

    <div class="main-contents">
      <Transition :name="formFadeName">
        <RegistrationForm v-if="formShow" @onSuccess="onSuccess" />
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';

import $assets from '@/assets';
import RegistrationForm from '@/components/form/RegistrationForm.vue';
import AgencyService from '@/services/agency';
import CityService from '@/services/city';
import ProvinceService from '@/services/province';
import useMetaStore from '@/stores/meta';

const MetaStore = useMetaStore();

// #SAMPLE PROJECTS#
const welcomeShow = ref(true);
//
const formShow = ref(false);
const formFadeName = ref('fade');
//
const success = ref(false);

onBeforeMount(async () => {
  const agencyResults = await AgencyService.getAgencies();
  MetaStore.setAgencyList(agencyResults.records);

  const provinceResults = await ProvinceService.getProvinces();
  MetaStore.setProvinceList(provinceResults.records);

  const cityResults = await CityService.getCities();
  MetaStore.setCityList(cityResults.records);

  // Production process
  setTimeout(() => {
    welcomeShow.value = false;
  }, 400);
  setTimeout(() => {
    formShow.value = true;
  }, 600);
});

function onSuccess() {
  success.value = true;
}
</script>

<style scoped>
#main {
  position: relative;
  width: 100%;
  height: 100%;
}

.bg {
  position: fixed;
  left: 0;
  top: 0;

  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #75c7ab, #60c7ce, #4e99d0);
}

.intro-title {
  position: absolute;
  left: 0;
  top: 40%;

  width: 100%;
  color: white;
  font-size: 1.4em;
  font-weight: 700;
  text-align: center;
}

.hub-logo {
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 2em;
  height: 15em;
  padding: 0 1em;
}
.hub-logo img {
  height: 45%;
}
.hub-logo p {
  color: white;
  font-size: 1.2em;
  text-align: center;
}

.main-contents {
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;
  width: 100%;
  height: 100%;
}

/* TRNASITIONS */
/* registration, intro-Title  */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .hub-logo img {
    height: 40%;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .hub-logo {
    margin-top: 5em;
    height: 15em;
  }
}
</style>
